import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createVNode as _$cv, className as _$cn } from 'intact-vue';
import { getRestProps, eachChildren } from '../utils';
import { Step } from './step';
import { makeStyles } from './styles';
import { context as StepsContext } from './context';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    value = _this$get.value,
    status = _this$get.status,
    type = _this$get.type,
    clickable = _this$get.clickable,
    vertical = _this$get.vertical;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-steps"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + type] = true, _classNameObj[k + "-clickable"] = clickable, _classNameObj[k + "-vertical"] = vertical, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var stepIndex = 0;
  var steps = [];
  eachChildren(children, function (vNode) {
    if (vNode.tag === Step) {
      vNode.props = _extends({}, vNode.props, {
        index: stepIndex
      });
      steps.push(vNode);
      stepIndex++;
    }
  });

  // add width
  /* const width = (100 / stepIndex) + '%';  */

  return _$cc(StepsContext.Provider, {
    'value': {
      value: value,
      status: status,
      /* width, */
      type: type,
      onChange: this.changeIndex
    },
    'children': _$cv('div', _extends({
      'className': _$cn(classNameObj)
    }, getRestProps(this)), steps)
  });
}
;